module.exports = __webpack_public_path__ + "static/media/image-2.0531592e.png";